/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type UserChangePinInput = {
    readonly userId: string;
    readonly pin: string;
    readonly clientMutationId?: string | null;
};
export type UserChangePinMutation_MutationVariables = {
    readonly input: UserChangePinInput;
};
export type UserChangePinMutation_MutationResponse = {
    readonly userChangePin: ({
        readonly clientMutationId: string | null;
    }) | null;
};
export type UserChangePinMutation_Mutation = {
    readonly response: UserChangePinMutation_MutationResponse;
    readonly variables: UserChangePinMutation_MutationVariables;
};



/*
mutation UserChangePinMutation_Mutation(
  $input: UserChangePinInput!
) {
  userChangePin(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UserChangePinInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "userChangePin",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UserChangePinInput!"
      }
    ],
    "concreteType": "UserChangePinPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "UserChangePinMutation_Mutation",
  "id": null,
  "text": "mutation UserChangePinMutation_Mutation(\n  $input: UserChangePinInput!\n) {\n  userChangePin(input: $input) {\n    clientMutationId\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UserChangePinMutation_Mutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "UserChangePinMutation_Mutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
(node as any).hash = '6bf7407275e69cc664e452641afc57c5';
export default node;
